import React from 'react';
import { Grid } from '@lux/grid';
import { Translate, TranslateScope } from '@pegasus/translation';
import { ErrorMessage as PErrorMessage } from '@pegasus/error-boundary';
var onCtaClick = function () {
    window.location.assign('/event');
};
export var ErrorMessage = function (_a) {
    var _b = _a.path, path = _b === void 0 ? 'errors.generic' : _b, withCta = _a.withCta;
    return (React.createElement(TranslateScope, { path: path }, withCta ? (React.createElement(PErrorMessage, { title: React.createElement(Translate, { message: "title" }), text: React.createElement(Translate, { message: "bodyMyLounge" }), ctaText: React.createElement(Translate, { message: "ctaMyLounge" }), ctaClick: onCtaClick })) : (React.createElement(PErrorMessage, { title: React.createElement(Translate, { message: "title" }), text: React.createElement(Translate, { message: "body" }) }))));
};
export var ErrorMessageFullScreen = function (_a) {
    var path = _a.path, _b = _a.withCta, withCta = _b === void 0 ? true : _b;
    return (React.createElement(Grid, null,
        React.createElement("div", { className: "flex h-screen items-center justify-center" },
            React.createElement("div", { className: "w-[420px]" },
                React.createElement(ErrorMessage, { path: path, withCta: withCta })))));
};
